import { WineTypes } from '@/common/constant';
import { Button, Select, Space } from 'antd';

interface WineTypeSelectProps {
  value?: string[];
  onChange?: (value: string[]) => void;
}

const ONLY_WINE = [
  'red',
  'white',
  'sparkling',
  'rosé',
  'dessert',
  'sherry',
  'port',
  'orange',
];

export function WineTypeSelect({ value = [], onChange }: WineTypeSelectProps) {
  const handleSelectAll = () => {
    if (value.length === WineTypes.length) {
      onChange?.([]);
    } else {
      onChange?.(WineTypes);
    }
  };

  const handleOnlyWine = () => {
    onChange?.(ONLY_WINE);
  };

  const isAllSelected = value.length === WineTypes.length;
  const isOnlyWine =
    value.length === ONLY_WINE.length &&
    ONLY_WINE.every((type) => value.includes(type));

  return (
    <Space direction="vertical" className="w-full">
      <Space>
        <Button
          size="small"
          onClick={handleSelectAll}
          type={isAllSelected ? 'primary' : 'default'}
        >
          {isAllSelected ? 'Deselect All' : 'Select All'}
        </Button>
        <Button
          size="small"
          onClick={handleOnlyWine}
          type={isOnlyWine ? 'primary' : 'default'}
        >
          Only Wine
        </Button>
      </Space>
      <Select
        mode="multiple"
        allowClear
        maxTagCount={5}
        placeholder="Select wine types"
        value={value}
        onChange={onChange}
        options={WineTypes.map((type) => ({
          label: type,
          value: type,
        }))}
      />
    </Space>
  );
}
